/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type UtxAlternativesGetListBy = typeof UtxAlternativesGetListBy[keyof typeof UtxAlternativesGetListBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UtxAlternativesGetListBy = {
  assetName: 'assetName',
  marketValue: 'marketValue',
} as const;
